import DOMPurify from 'dompurify';

// Imported lessons and banners need their CSS and embedded forms/videos.
// Sanitization still strips executable markup, event handlers and unsafe URLs.
// srcdoc would allow a second, unsanitized document inside a kept iframe.
export function sanitizeHtml(content: string): string {
  return DOMPurify.sanitize(content || '', {
    ADD_TAGS: ['style', 'iframe'],
    ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling'],
    FORBID_TAGS: ['script', 'object', 'embed', 'base', 'meta', 'link'],
    FORBID_ATTR: ['srcdoc'],
  });
}
